import React, { createContext } from 'react'
import { EventStackProvider } from '../use-event-stack'

export const ClickAwayContext = createContext(null)

// This is used by useEventStack to identify the hook when this provider isn't provided.
ClickAwayContext.hookName = 'useClickAway'

export const ClickAwayProvider = ({ children }) => (
  <EventStackProvider eventType="click" Context={ClickAwayContext}>
    {children}
  </EventStackProvider>
)
